export default "__VITE_ASSET__C_ZsC6dA__"